/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamStageGateResponse } from './oralExamStageGateResponse';

export type OralExamCohortStateResponseStageGate = OralExamStageGateResponse | null;
